import React, { Fragment, useState } from "react"
import { Table } from "react-bootstrap"
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import InputNumber from "../../../utilities/Form/InputNumber";
import { formatNumber } from "../../../utilities/Class/FormatNumber";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

export default function DataReturn(props) {
    let arr = props?.return || [];
    let unit = props?.unit || [];
    let summary = props?.summary || [];
    let record = props?.record || [];
    let warehouse = props?.warehouse.map(wh => ({
        value: wh.value,
        label: wh.label,
        idWH: wh.helper,
        idSubWH: wh.helper2
    }));
    return (
        <Fragment key={`data-return`}>
            {arr.map((item, i) => (
                <Fragment key={`header-${i}`}>
                    <form className="my-5">
                        <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-xl p-6 space-y-4">
                            <div className="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                                <div className="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                                    <div className="row" style={{ fontSize: '16px' }}>
                                        <div className="col">
                                            <p><strong>{i18n.t('Date')} : </strong>{item.date}</p>
                                        </div>
                                        <div className="col">
                                            <p><strong>{i18n.t('Taking Goods No.')} : </strong>{item.no_tr}</p>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row" >
                                    <div className="col-12 " style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                        {i18n.t("Detail")}
                                    </div>
                                </div>
                                <Table striped bordered hover className="border" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    <thead>
                                        <tr className="border" style={{ backgroundColor: '#68829E', color: 'white' }}>
                                            <th width={"3%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No.")}</th>
                                            <th width={"15%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Item")}</th>
                                            <th width={"8%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No. Band")}</th>
                                            <th width={"25%"} className="text-center" colSpan={((unit?.length || 0) + 1)}>{i18n.t("Taking")}</th>
                                        </tr>
                                        <tr className="border">
                                            {(unit?.length > 0) ?
                                                unit.map((header, s) => {
                                                    return <th key={`headerReturn-${i}` + s} width={"5%"} className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{header.name}</th>
                                                })
                                                : null}
                                            <th key={`headerConvert-${i}1`} width={"8%"} className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Convert (Pack)")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderList(item?.detail || [], i)}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </form>
                    <br />
                </Fragment>
            ))}
            <div className="row" >
                <div className="col-12 " style={{ fontWeight: 'bold', fontSize: '20px' }}>
                    {i18n.t("SUMMARY")}
                </div>
            </div>
            <Fragment key={`data-summary`}>
                <form className="my-5">
                    <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-xl p-6 space-y-4">
                        <div className="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                            <div className="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                            </div>
                            <hr />
                            <Table bordered className="border" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                <thead>
                                    <tr className="border" style={{ backgroundColor: '#68829E', color: 'white' }}>
                                        <th width={"3%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No.")}</th>
                                        <th width={"21%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Item")}</th>
                                        <th width={"8%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No. Band")}</th>
                                        <th width={"33%"} className="text-center pb-10" colSpan={3}>{i18n.t("Record Last Stock")}</th>
                                        <th width={"9%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Selling (Pack)")}</th>
                                        <th width={"23%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Warehouse")}</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {renderListSummary(summary)}
                                </tbody>
                            </Table>


                        </div>
                    </div>
                </form>
                <br />
            </Fragment>
        </Fragment>
    );


    function handleReturnChange(value, rowIndex, unitIndex, idUnit) {
        const updatedSummary = [...props.summary];
        const targetRow = updatedSummary[rowIndex];

        if (!targetRow.return) targetRow.return = [];
        if (!targetRow.return[unitIndex]) targetRow.return[unitIndex] = {};

        const unitDetail = targetRow.item_qty;
        const convertion = unitDetail.find(item => item.idUnit == idUnit);
        console.log("CON",convertion)
        const con = convertion?.qty || 0;
        const qty = parseFloat(value || 0);
        const qtyConvert = qty * con;

        const tempReturn = [...targetRow.return];
        tempReturn[unitIndex] = {
            ...tempReturn[unitIndex],
            qty,
            qtyConvert,
        };

        let totalConvertInput = tempReturn.reduce(
            (sum, item) => sum + (item?.qtyConvert || 0),
            0
        );
        if (totalConvertInput > (targetRow.total_convert - targetRow.total_sell)) {
          
            targetRow.return[unitIndex] = {
                id: convertion?.idUnit,
                unit: convertion?.nameUnit,
                convertion: convertion?.qty,
                qty: 0,
                qtyConvert,
            };
            console.log('1',targetRow)
              totalConvertInput = tempReturn.reduce(
                (sum, item) => sum + (item?.qtyConvert || 0),
                0
            );

            targetRow.convertReturn = totalConvertInput;

             MySwal.fire({
                title: "Information",
                html: 'Item ' + targetRow.name_item + ' Qty yang dimasukkan melebihi item yang dibawa!',
                icon: "info",
                showConfirmButton: true,
            });
            // alert('Item ' + targetRow.name_item + ' Qty yang dimasukkan melebihi item yang dibawa!');
           

            
            // totalConvertInput = tempReturn.reduce(
            //     (sum, item) => sum + (item?.qtyConvert || 0),
            //     0
            // );

            
        } else {
            targetRow.return[unitIndex] = {
                id: convertion?.idUnit,
                unit: convertion?.nameUnit,
                convertion: convertion?.qty,
                qty,
                qtyConvert,
            };
        }

        // Valid, simpan ke state

        // targetRow.return = tempReturn;        
        targetRow.convertReturn = totalConvertInput;

        props.setSummary(updatedSummary);
    }

    function renderList(data, i) {
        let no = 1;
        return (
            <Fragment key={`data-detail-${i}`}>
                {data.map((detail, p) => (
                    <Fragment key={`data-header-${i}-detail-${p}`}>
                        <tr>
                            <td style={{ textAlign: 'center' }}>{no + p}</td>
                            <td style={{ textAlign: 'left' }}>{detail.name_item}</td>
                            <td style={{ textAlign: 'center' }}>{detail.band_no}</td>
                            {unit?.length > 0
                                ? unit.map((header, s) => {
                                    const found = detail.detail.find(
                                        u => parseInt(u.id) === parseInt(header.id)
                                    );
                                    return (
                                        <td key={`unit-${p}-${s}`} style={{ textAlign: 'center' }}>
                                            {found ? formatNumber(found.qty) : 0}
                                        </td>
                                    );
                                })
                                : null}
                            <td style={{ textAlign: 'center' }}>{formatNumber(detail.convert)}</td>
                        </tr>
                    </Fragment>
                ))}
            </Fragment>
        );
    }

    function renderListSummary(data) {
        let no = 1;

        return (
            <Fragment key={`data-detail-summary-}`}>
                {data.map((detail, p) => (
                    <Fragment key={`data-header-summary-detail-${p}`}>
                        <tr className="border" >
                            <td style={{ textAlign: 'center' }} rowSpan={detail.item_det.length + 2}>{no + p}</td>
                            <td style={{ textAlign: 'left' }} rowSpan={detail.item_det.length + 2}>{detail.name_item}</td>
                            <td style={{ textAlign: 'center' }} rowSpan={detail.item_det.length + 2}>{detail.band_no}</td>
                            <td className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Unit")}</td>
                            <td className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Qty Taking")}</td>
                            <td className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Qty Return")}</td>
                            <td style={{ textAlign: 'center' }}>{formatNumber(detail.total_sell)}</td>
                            <td>
                                <Select2
                                    isClearable={true}
                                    name={'warehouse'}
                                    required={true}
                                    className={""}
                                    size={4}
                                    title={i18n.t('Warehouse')}
                                    placeholder={i18n.t('Select Warehouse')}
                                    labelfield={"false"}
                                    options={warehouse}
                                    onChange={(val) => handleWarehouseChange(val, p)}
                                />
                                <div className="fv-plugins-message-container invalid-feedback">
                                </div>
                            </td>
                        </tr>

                        {detail.item_det.length > 0
                            ? detail.item_det?.map((header, s) => {
                                const found = detail.detail.find(
                                    u => parseInt(u.id) === parseInt(header.idUnit)
                                );
                                return (
                                    <tr key={`unit-${p}-${s}`} className="border text-center" >
                                        <td >{header.nameUnit}</td>
                                        <td style={{ width: '10%' }}>{found ? formatNumber(found.qty) : 0}</td>
                                        <td key={`unitItem-${p}` + s} style={{ width: '10%', paddingRight: "10px" }}>
                                            <InputNumber
                                                id={header.idUnit}
                                                name={header.nameUnit}
                                                labelfield={"false"}
                                                value={
                                                    props.summary[p]?.return?.[s]?.qty ??
                                                    getInitialQty(record, detail.id_item, detail.band_no, header.idUnit, p, s)
                                                }
                                                onValueChange={(val) => handleReturnChange(val, p, s, header.idUnit)}
                                                className="form-control form-control-sm text-end"
                                            />
                                            {/* </div>
                                        </div> */}
                                        </td>
                                    </tr>
                                );
                            })
                            : null}

                        <tr key={`headerConvert-${p}2`} width={"8%"} className="border text-center" style={{ backgroundColor: '#808080', color: 'white' }}>
                            <td>{i18n.t("Convert (Pack)")}</td>
                            <td>{formatNumber(detail.total_convert)}</td>
                            <td style={{ width: '10%', paddingRight: "10px", backgroundColor: '#808080', color: 'black' }}>
                                <InputNumber
                                    id={"convertReturn"}
                                    name={"convertReturn"}
                                    labelfield={"false"}
                                    value={props.summary[p]?.convertReturn ?? getInitialConvert(record, detail.id_item, detail.band_no, summary, p)}
                                    // value={props.summary[p]?.convertReturn || 0}
                                    decimalsLimit={2}
                                    disabled={true}
                                    className="form-control form-control-sm text-end"
                                />
                            </td>
                        </tr>
                    </Fragment>
                ))}
            </Fragment>
        );
    }

    function handleWarehouseChange(selectedOption, rowIndex) {
        const updatedSummary = [...props.summary];
        const targetRow = updatedSummary[rowIndex];

        targetRow.warehouse = selectedOption; // atau pilih fieldnya: selectedOption?.value, dst

        props.setSummary(updatedSummary);
    }

    function getInitialQty(record, id_item, band_no, id_unit, rowIndex, unitIndex) {
        if (record.length > 0) {
            const found = record.find(item => item.id_item === id_item && item.band_no === band_no);
            // const summary = record.find(item => item.id_item === id_item && item.band_no === band_no);
            const updatedSummary = [...props.summary];
            const targetRow = updatedSummary[rowIndex];
            if (!targetRow.return) targetRow.return = [];

            if (!found) return 0;

            const detail = found.detail?.find(d => d.id_unit === id_unit);
            targetRow.return[unitIndex] = {
                id: rowIndex,
                qty: detail?.qty || 0,
                qtyConvert: detail?.qtyConvert || 0,
            };

            props.setSummary(updatedSummary);

        }
        else {
            const updatedSummary = [...props.summary];
            const targetRow = updatedSummary[rowIndex];
            if (!targetRow.return) targetRow.return = [];
            const detail = targetRow.detail?.find(d => d.id == id_unit);
            if (!detail) return 0;
            targetRow.return[unitIndex] = {
                id: rowIndex,
                qty: 0 || 0,
                qtyConvert: 0 || 0,
            };
            props.setSummary(updatedSummary);
        }
    }

    function getInitialConvert(record, id_item, band_no, summary, rowIndex) {
        if (record.length > 0) {
            const found = record.find(item => item.id_item === id_item && item.band_no === band_no);
            return found?.total_convert || 0;
        } else {
            const updatedSummary = [...props.summary];
            const targetRow = updatedSummary[rowIndex];
            if (!targetRow.return) targetRow.return = [];
            return  0;
        }
    }


}

